import { render } from "./currencyInput.vue?vue&type=template&id=5aac9a92"
import script from "./currencyInput.vue?vue&type=script&lang=js"
export * from "./currencyInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__